<mat-form-field appearance="outline" appFormFieldFilled>
    <input matInput #addressInput
           [formControl]="formControl"
           autocomplete="off"
           name="avoidSearch"
           [placeholder]="placeholder"
           (focus)="onFocus.emit(true)"
           (focusout)="onFocus.emit(false)"
           enterkeyhint="next"
           [matAutocomplete]="addressAutocomplete"
           (keydown.enter)="$event.preventDefault(); $event.stopImmediatePropagation()"
           [anchorAutocompleteOnScroll]="addressTrigger"
           #addressTrigger="matAutocompleteTrigger"
    />
    <mat-autocomplete #addressAutocomplete="matAutocomplete" (click)="click()">
        <mat-option (click)="addressInput.blur()" (placeOptionClick)="onPlacesOptionSelected($event)" *ngFor="let option of addressPredictions$ | async" [value]="option">
            {{ option.description }}
        </mat-option>
    </mat-autocomplete>
    <mat-error *ngIf="error">{{ error }}</mat-error>
</mat-form-field>